<template>
  <v-container fluid class="fill-height pa-1" v-resize="onResize">
    <!-- Tabulka s číselníkem -->
    <v-data-table
      :headers="TabHeaders"
      :items="VybZaznamy"
      :items-per-page="13"
      :search="TabSearch"
      :loading="IsLoading"
      class="rounded-lg"
      dense
      fixed-header
      multi-sort
      :height="TabHeight"
    >
      <template v-slot:top>
        <v-card outlined class="pa-2">
          <v-row ref="DivTabHeader">
            <v-col cols="auto">
              <v-card width="270">
                <v-select
                  v-model="VybCis"
                  :items="SeznamCis"
                  item-text="Popis"
                  return-object
                  label="Číselník"
                  color="primary"
                  filled
                  dense
                  background-color="secondary"
                  hide-details="true"
                  class="mb-2"
                ></v-select>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-card width="135">
                <v-select
                  v-model="VybRocnik"
                  :items="SeznamRocnik"
                  label="Ročník"
                  color="primary"
                  filled
                  dense
                  background-color="secondary"
                  hide-details="true"
                  class="mb-2"
                ></v-select>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-card width="200">
                <v-text-field
                  label="Hledaný výraz"
                  append-icon="mdi-magnify"
                  v-model="TabSearch"
                  hide-details="true"
                  class="mb-2"
                ></v-text-field>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </template>

      <template v-slot:item.Vlast_01="{ item }">
        <v-chip color="primary2" class="my-1">
          {{ item.Vlast_01 }}
        </v-chip>
      </template>
    </v-data-table>

    <!-- Upozornění -->
    <v-dialog v-model="Alert_view" max-width="400">
      <v-alert
        class="pa-4 ma-0"
        type="error"
        dense
        icon="mdi-alert-circle-outline"
        >{{ Alert_text }}
      </v-alert>
    </v-dialog>
  </v-container>

  <!-- <v-alert type="success"> Modul dosud není hotov. </v-alert> -->
</template>

<script>
import ServiceLhpo from "../services/ServiceLhpo";

export default {
  props: {
    // Jméno komponenty
    CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },

  data() {
    return {
      // Seznam číselníků
      SeznamCis: [],
      // Vybraný číselník
      VybCis: null,
      // Seznam číselníků
      SeznamRocnik: [],
      // Vybraný ročník
      VybRocnik: null,
      // zobrazená data
      VybZaznamy: [],

      // Tabulka - hlavička
      TabHeaders: [{ text: "Kód", value: "Vlast_01" }],
      // Tabulka - Hledání
      TabSearch: null,
      // Tabulka - Výška
      TabHeight: null,

      // Upozornění
      Alert_view: false,
      // Upozornění - text
      Alert_text: "",

      // Nahrávám
      IsLoading: false,

      // Výška tabulky
      Tab_Seznam_Height: 300,
    };
  },

  methods: {
    // při změně velikosti
    onResize: function () {
      // změna výšky tabulky - velikosto okna-hlavička-zápatí-hlavička tabulky-zápatí tabulky-margin
      if (!(this.$refs.DivTabHeader == null)) {
        this.TabHeight =
          window.innerHeight -
          48 -
          42 -
          this.$refs.DivTabHeader.clientHeight -
          59 -
          2;
      }
    },

    // Nová data
    NoveZaznamy: function () {
      var vHead = [];

      this.VybCis.Vlastnosti.forEach(function (item, index) {
        vHead[index] = { text: item.Popis, value: "Vlast_0" + (index + 1) };
      });

      this.TabHeaders = vHead;
      this.VybZaznamy = this.VybCis.Zaznamy;
    },

    // WS - Seznam číselníků
    NactiDsSeznamCis: function () {
      ServiceLhpo.DsSeznamCis("islh_lhc_1rok")
        .then((response) => {
          if (response.data.Dokonceno) {
            this.SeznamCis = response.data.SeznamCis;
            this.VybCis = this.SeznamCis[0];
            this.SeznamRocnik = response.data.SeznamCisRocnik;
            this.VybRocnik = this.SeznamRocnik[0];
            this.IsLoading = false;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.VybSeznamLhc = null;
        })
        .then(function () {
          // always executed
        });
    },

    // WS - Číselník
    NactiDsCis: function (CisJmeno, Rocnik) {
      ServiceLhpo.DsCis("islh_lhc_1rok", CisJmeno, Rocnik)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.VybCis = response.data.Ciselnik;
            this.NoveZaznamy();
            this.IsLoading = false;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.VybSeznamLhc = null;
        })
        .then(function () {
          // always executed
        });
    },
  },

  watch: {
    VybCis: function (value, oldValue) {
      // Když není první načtení
      if (oldValue !== null && typeof oldValue !== "undefined") {
        // Když se nejedná pouze o načtení hodnot
        if (oldValue.Jmeno !== value.Jmeno) {
          // Vyplněn ročník
          if (
            this.VybRocnik !== null &&
            typeof this.VybRocnik !== "undefined"
          ) {
            this.IsLoading = true;
            this.VybZaznamy = [];
            this.NactiDsCis(value.Jmeno, this.VybRocnik);
          }
        }
      }
    },

    VybRocnik: function (value) {
      if (value !== null && typeof value !== "undefined") {
        this.IsLoading = true;
        this.VybZaznamy = [];
        this.NactiDsCis(this.VybCis.Jmeno, value);
      }
    },
  },

  mounted() {
    // Vytvoření

    // Nastavení služby
    ServiceLhpo.Init(this.AppServiceurl.ServiceLhpo);

    // první načtení seznamu
    this.IsLoading = true;
    // nový seznam Ds
    this.NactiDsSeznamCis();

    this.onResize();
  },
};
</script>

<style>
</style>